export const join = (nameArray: any[], seperator = ', ') => {
    return (
        nameArray
            ?.map((item: any) => (typeof item === 'string' && item === ' ' ? '' : item))
            .filter(Boolean)
            .join(seperator) || ''
    );
};
